<geaui-page-layout [headerTemplate]="header" [contentTemplate]="content" [sidebarTemplate]="sidebar">
  <ng-template #header>
    <geaui-header [noAuth]="noAuth" [headerTitle]="APP_TITLE" [showBanner]="false"></geaui-header>
  </ng-template>

  <ng-template #content>
    <div class="content-body">
      <router-outlet></router-outlet>
    </div>
  </ng-template>

  <ng-template #sidebar>
    <geaui-sidebar-v2 [navigationItems]="navitationItems" [devisionName]="title"
      [devisionIconPath]="'assets/icons/GEA-EvoDry.svg'" devisionIconBackgroundColor="var(--geaui-primary)">
    </geaui-sidebar-v2>
  </ng-template>

</geaui-page-layout>
